<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" :rules="rules" ref="queryParams" class="form" size="small" label-width="80px">
					<el-form-item label="日期范围" prop="createDates">
						<el-date-picker v-model="queryParams.createDates" type="datetimerange" :picker-options="pickerOptions" range-separator="至" start-placeholder="开始日期"
							end-placeholder="结束日期" align="right" value-format="yyyy-MM-dd HH:mm" :default-time="['00:00:00', '00:00:00']">
						</el-date-picker>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleMerge">合并分析</el-button>
					</el-form-item>
				</el-form>
			</el-col>
			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column label="" width="40px">
						<template slot-scope="scope">
							<el-checkbox v-model="scope.row.checked" :disabled="scope.row.disabled" @change="checkedChange"></el-checkbox>
						</template>
					</el-table-column>
					<el-table-column prop="preference" label="分析偏好"></el-table-column>
					<el-table-column prop="title" label="分析名称"></el-table-column>
					<el-table-column prop="deviceTitle" label="分析设备"></el-table-column>
					<el-table-column prop="imageList" label="上传图片" width="80">
						<template slot-scope="scope">
							{{scope.row.imageList |getImageLength}}
						</template>
					</el-table-column>
					<el-table-column prop="description" label="备注"></el-table-column>
					<el-table-column prop="creatorName" label="分析人"></el-table-column>
					<el-table-column prop="createTime" label="提交时间"></el-table-column>
					<el-table-column fixed="right" label="操作" width="80">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)">查看</el-button>
						</template>
					</el-table-column>
				</el-table>
			</el-col>
		</el-row>

		<el-dialog title="查看分析记录" :visible.sync="dialogVisible" width="600px" :close-on-click-modal="false">
			<el-row>
				<el-descriptions class="margin-top" :column="1" :labelStyle="label_style">
					<el-descriptions-item label="分析名称">
						{{addOrUpdateForm.title}}
					</el-descriptions-item>
					<el-descriptions-item label="关联设备">
						{{addOrUpdateForm.deviceTitle}}
					</el-descriptions-item>
					<el-descriptions-item label="上传照片">
						<span class="el-descriptions-item__content">
							<div>
								<ul class="el-upload-list el-upload-list--picture-card">
									<li tabindex="0" class="el-upload-list__item is-success" v-for="(image,index) in addOrUpdateForm.imageList" :key="index">
										<el-image style="width: 80px; height: 80px" :src="image" fit="fit" :preview-src-list="addOrUpdateForm.imageList"></el-image>
									</li>
								</ul>
							</div>
						</span>
					</el-descriptions-item>
					<el-descriptions-item label="备注">
						<el-input type="textarea" :disabled="true" resize="none" :autosize="{ minRows: 3}" v-model="addOrUpdateForm.description"></el-input>
					</el-descriptions-item>
					<el-descriptions-item label="分析内容">
					</el-descriptions-item>
				</el-descriptions>
				<el-table v-loading="loading" :data="addOrUpdateForm.datas" stripe border style="width: 510px;margin-left: 50px;" tooltip-effect="dark">
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="name" label="项目名称"></el-table-column>
					<el-table-column prop="deviceTitle" label="分析内容">
						<template slot-scope="scope">
							{{scope.row.content}}{{scope.row.unit}}
						</template>
					</el-table-column>
				</el-table>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="dialogVisible = false">取 消</el-button>
			</div>
		</el-dialog>

		<el-dialog class="mydialog" :visible.sync="dialogEchartsVisible" width="1200px" :close-on-click-modal="false" :show-close="false">
			<el-row>
				<div class="chart_header">
					<div class="chart_title">分析数据</div>
					<div class="chart_name" v-if="content.name">
						<span>{{content.name}}</span> |
						<span>最大值：{{content.maxValue}}</span>
						<span>最小值：{{content.minValue}}</span>
						<span>平均值：{{content.avgValue}}</span>
					</div>
				</div>
				<div ref="chart" style="width: 100%; height: 300px"></div>
				<el-table :data="chartOptions.series" stripe border style="width: 1100px;margin-top: 5px;;margin-left: 50px;" tooltip-effect="dark">
					<el-table-column type="index" label="序号"></el-table-column>
					<el-table-column prop="name" label="项目名称"></el-table-column>
					<el-table-column v-for="(column, index) in this.chartOptions.xAxis.data" :key="index" :prop="column" :label="column">
						<template slot-scope="scope">
							{{scope.row.data[index]}}
						</template>
					</el-table-column>
				</el-table>
			</el-row>
			<div slot="footer" class="dialog-footer">
				<el-button size="small"  type="primary" @click="download()">导 出</el-button>
				<el-button size="small" @click="dialogEchartsVisible = false">关 闭</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';
	import * as echarts from 'echarts';

	export default {
		extends: BaseSearch,
		props: ['device'],
		data() {
			return {
				dialogEchartsVisible: false,
				queryParams: {
					currentPage: 1,
					pageSize: 10000,
					createDates: []
				},
				url: 'analysis/log',
				name: '分析记录',
				label_style: {
					'width': "100px",
					'float': 'right',
					'text-align': 'right',
					'display': 'block',
					'word-break': 'break-all'
				},
				pickerOptions: {
					shortcuts: [{
						text: '最近7天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', [start, end]);
						}
					}, {
						text: '最近30天',
						onClick(picker) {
							const end = new Date();
							const start = new Date();
							start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
							picker.$emit('pick', [start, end]);
						}
					}],
					disabledDate(time) {
						const now = new Date();
						const thirtyDaysAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 30天前
						return time.getTime() < thirtyDaysAgo.getTime();
					}
				},
				chartOptions: {
					tooltip: {
						trigger: 'axis'
					},
					legend: {
						data: [],
						bottom: 0
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					},
					xAxis: {
						type: 'category',
						boundaryGap: true,
						data: [],
					},
					yAxis: {
						type: 'value'
					},
					series: []
				},
				myChart: null,
				contents: [],
				content: {},
				currData:null
			};
		},
		filters: {
			getImageLength(list) {
				if (list) {
					return "+" + list.length;
				}
				return 0;
			}
		},
		methods: {
			beforeEdit() {
				if(this.addOrUpdateForm.extra){
					this.addOrUpdateForm.datas = JSON.parse(this.addOrUpdateForm.extra)
				}else{
					this.addOrUpdateForm.datas = []
				}
			},
			setDefaultTimeRange() {
				const now = new Date(); // 当前时间
				const twoHoursAgo = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000); // 前两个小时
				const startTime = this.formatDate(twoHoursAgo);
				const endTime = this.formatDate(now);
				this.queryParams.createDates = [startTime, endTime];
				this.$forceUpdate(); // 强制更新组件
			},
			formatDate(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');
				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},
			beforeList(datas) {
				if (datas) {
					datas.forEach(item => {
						item.checked = false;
						item.disabled = false;
					})
				}
			},
			checkedChange(value) {
				var preference = null;
				var creatorId = null
				this.datas.forEach(item => {
					if (item.checked) {
						preference = item.preference;
						creatorId = item.creatorId
					}
				})
				if (preference) {
					this.datas.forEach(item => {
						if (item.preference == preference && item.creatorId == creatorId) {
							item.disabled = false;
						} else {
							item.disabled = true;
						}
					})
				} else {
					this.datas.forEach(item => {
						item.disabled = false;
					})
				}
			},
			handleMerge() {
				var keys = []
				var dict = {}
				this.chartOptions.xAxis.data = []
				this.datas.forEach(item => {
					if (item.checked && item.extra) {
						this.currData=item
						var list = JSON.parse(item.extra);
						list.forEach(value => {
							if (!keys.includes(value.name)) {
								keys.push(value.name)
								dict[value.name] = []
							}
						})
						this.chartOptions.xAxis.data.push(item.createTime)
					}
				})
				if (keys.length == 0) {
					return;
				}
				this.chartOptions.xAxis.data.forEach(x => {
					keys.forEach(key => {
						dict[key].push({});
					})
				})
				var index = 0;
				this.datas.forEach(item => {
					if (item.checked) {
						var list = JSON.parse(item.extra);
						list.forEach(value => {
							dict[value.name][index] = {
								value: value.content,
								unit: value.unit
							}
						})
						index++;
					}
				})
				this.chartOptions.series = []
				keys.forEach(key => {
					const output = dict[key].map(item => item.value ? parseFloat(item.value) : null);
					this.chartOptions.series.push({
						name: key,
						type: 'line',
						stack: 'Total',
						data: output,
						markPoint: {
							data: [{
									type: 'max',
									name: 'Max'
								},
								{
									type: 'min',
									name: 'Min'
								}
							]
						},
						markLine: {
							data: [{
								type: 'average',
								name: 'Avg'
							}]
						}
					});
				})
				this.chartOptions.legend.data = keys;
				this.dialogEchartsVisible = true
				this.$nextTick(() => {
					if (!this.myChart) {
						var chartDom = this.$refs.chart;
						this.myChart = echarts.init(chartDom);
					}
					this.myChart.setOption(this.chartOptions, {
						notMerge: true
					});
					// 绑定点击事件
					this.myChart.on("click", this.handleChartClick);
					this.myChart.resize();
				});
			},
			handleChartClick(params) {
				const seriesIndex = params.seriesIndex;
				const seriesName = params.seriesName;
				const seriesData = this.chartOptions.series[seriesIndex].data;
				const validValues = seriesData.filter(value => value !== null && !isNaN(value));
				this.content = {
					name: seriesName,
					maxValue: null,
					minValue: null,
					avgValue: null
				}
				if (validValues.length > 0) {
					const max = Math.max(...validValues);
					const min = Math.min(...validValues);
					const average = validValues.reduce((sum, value) => sum + value, 0) / seriesData.length;
					this.content.maxValue = max
					this.content.minValue = min
					this.content.avgValue = average
				}
			},
			download() {
				var headers = ['序号','项目名称']
				var datas =[]
				if(this.chartOptions.xAxis.data){
					headers = headers.concat(this.chartOptions.xAxis.data)
				}
				if(this.chartOptions.series){
					this.chartOptions.series.forEach((value,index) => {
						var data = [index+1,value.name];
						data = data.concat(value["data"])
						datas.push(data)
					})
				}
				var params = {
					preference:this.currData.preference,
					creatorName:this.currData.creatorName,
					headers:headers,
					datas:datas
				}
				console.log(params);
				debugger;
				
				this.$http({
					method: 'POST',
					url: '/analysis/log/export',
					data: params,
					responseType: 'arraybuffer'
				})
				.then(response => {
					const blob = new Blob([response.data], {
						type: response.headers['content-type']
					});
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement('a');
					a.href = url;
					a.download = decodeURIComponent(response.headers['content-disposition'].split(';')[1].split('=')[1]) || 'default.txt';
					a.click();
					window.URL.revokeObjectURL(url);
				})
			},
		},
		mounted: function() {
			if (this.device) {
				this.queryParams.deviceId = this.device.id
			}
			this.setDefaultTimeRange()
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}

	/deep/ .el-upload-list--picture-card .el-upload-list__item {
		width: 80px;
		height: 80px;
	}

	/deep/ .el-date-editor.el-input__inner,
	.handleQuery .el-date-editor.el-input {
		width: 380px !important;
		;
	}

	.el-date-editor {
		width: 400px;

		input {
			width: 148px !important;
		}
	}

	.mydialog {
		.el-dialog__header {
			padding: 0px
		}

		.el-dialog__body {
			padding-top: 5px;
		}
	}

	.chart_header {
		.chart_title {
			float: left;
			font-size: 18px;
			font-weight: bold;
		}

		.chart_name {
			float: right;
		}
	}
</style>


// WEBPACK FOOTER //
// src/view/front/log/analysisLog.vue